import { HandleApiError } from "sr/helpers/functions/HandleApiError";
import ApiResponse from "sr/models/ApiResponse";
import { remove } from "sr/utils/axios";

export const deleteEmployment = async (queryParams) => {
    try {
  return await remove<ApiResponse<[]>>(`/cleaner/employments?${queryParams}`).then((res)=>{
    if(res?.success===true){
        return res 
    }
    else {
        return null
    }
  })
}
catch(e){
    HandleApiError(e)
}
};
